import { genericPost, genericFilePost, genericDelete, genericPut, genericGet } from './apiService';
import { API_URL } from '../config/env';

const normalizeFilters = (filters) => {
  if (!Array.isArray(filters)) return [];
  return filters
    .filter((f) => f && (f.propertyName || f.PropertyName))
    .map((f) => ({
      propertyName: f.propertyName ?? f.PropertyName,
      operation: f.operation ?? f.Operation ?? '==',
      value:
        f.value === null || f.value === undefined
          ? ''
          : String(f.value ?? f.Value),
    }));
};

export const Getlist = async (filter, forcePublic = false) => {
  try {
    const hasToken = !!localStorage.getItem('authToken');
    const usePublic = forcePublic || !hasToken;
    const endpoint = usePublic ? 'Person/GetFilterPublic' : 'Person/GetFilter';
    const payload = {
      ...filter,
      filters: normalizeFilters(filter?.filters),
    };
    const response = await genericPost(`${API_URL}${endpoint}`, payload);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}; 
export const GetByPersonId = async (id) => {
  try {
    const hasToken = !!localStorage.getItem('authToken');
    const endpoint = hasToken
      ? `Person/GetByPersonId?id=${id}`
      : `Person/GetByPersonIdPublic?id=${id}`;
    const response = await genericGet(`${API_URL}${endpoint}`, null);
    return response;
  } catch (error) {
    console.error('Error in GetByPersonId:', error);
    throw error;
  }
};